import { useFilters } from '../../FlexflowContractListActions/hooks';
import { usePagination } from 'src/shared/hooks/usePagination';
import { useGetFlexflowContractsQuery } from 'src/shared/api/flexflow';
import { FlexflowContractsTab } from '../../Contracts';
import { defaultTableRowsPerPageOptions } from 'src/shared/constants/table';
import { hasReachedAnnualConsumptionLimit } from 'src/modules/Flexflow/utils/hasReachedAnnualConsumptionLimit';
import { useMemo } from 'react';
import { updateStatusIfNeeded } from 'src/modules/Flexflow/utils/updateStatusIfNeeded';

export const useTab2 = () => {
  const { setFilterValues, filterScheme, filterValues } = useFilters(FlexflowContractsTab.AFTER_ACTIVATION);
  const { handleChangePage, handleChangeRowsPerPage, page, rowsPerPage } = usePagination(
    defaultTableRowsPerPageOptions[1]
  );
  const queryParams = {
    pagination: { page: page + 1, perPage: rowsPerPage },
    filterValues
  };
  const { data: dataContracts, isLoading, isError, error } = useGetFlexflowContractsQuery(queryParams);

  const processedData = useMemo(() => {
    if (!dataContracts) return null;

    const mappedData = dataContracts.data.map(item =>
      updateStatusIfNeeded({
        data: item,
        suspendedByLimit: hasReachedAnnualConsumptionLimit(item.annualConsumptionPercentage)
      })
    );

    return {
      ...dataContracts,
      data: mappedData
    };
  }, [dataContracts]);

  return {
    setFilterValues,
    filterScheme,
    filterValues,
    handleChangePage,
    handleChangeRowsPerPage,
    page,
    rowsPerPage,
    data: processedData,
    isLoading,
    isError,
    error
  };
};
